<template>
  <div style="padding-top:100px;">
    <modal :product="product" v-if="showModal" @close="showModal = false" />
    <!-- start hero -->
    <div id="hero" class="jarallax" data-speed="0.7" data-img-position="50% 80%" style="background-image: url(img/1407.jpg);">
      <div class="container">
        <div class="row">
          <div class="col-12 col-lg-7">
            <h1 class="__title"><span>Nuestros</span>Productos</h1>
          </div>
        </div>
      </div>
    </div>
    <!-- end hero -->

   <!--  <div>
                <carousel :autoplay="true" :items="6" :dots="false" :loop="false" :nav="false" style="background-color:#fff;">
                  <img style="width: 100%; padding: 12px;" src="img/1200px-Logo_Bayer.svg.png">
                  <img style="width: 100%; padding: 12px;" src="img/1200px-Logo_Bayer.svg.png">
                  <img style="width: 100%; padding: 12px;" src="img/1200px-Logo_Bayer.svg.png">
                  <img style="width: 100%; padding: 12px;" src="img/1200px-Logo_Bayer.svg.png">
                  <img style="width: 100%; padding: 12px;" src="img/1200px-Logo_Bayer.svg.png">
                  <img style="width: 100%; padding: 12px;" src="img/1200px-Logo_Bayer.svg.png">
                  <img style="width: 100%; padding: 12px;" src="img/1200px-Logo_Bayer.svg.png">
                  <img style="width: 100%; padding: 12px;" src="img/1200px-Logo_Bayer.svg.png">
                  <img style="width: 100%; padding: 12px;" src="img/1200px-Logo_Bayer.svg.png">
                </carousel>
              </div> -->

              <!-- start main -->
              <main role="main">
                <link rel="stylesheet" type="text/css" href="css/style.min.css">

                <!-- start section -->
                <section id="appProducts" class="section" style="padding-top: 0px; padding-bottom: 40px;">
                  <div class="container">
                    <div class="row">

                      <div class="col-12 col-md-3">
                        <div style="padding: 16px; border:1px solid #43a553; border-radius: 4px; margin-top: 85px; color: #333;">
                          <div class="filter-wrapper">
                            <h4>Categoría</h4>
                            <ul>
                              <li v-for='category in categories'>
                                <div class="form-check">
                                  <input 
                                  type="checkbox" 
                                  :id="category.title" 
                                  class="form-check-input"
                                  :value="category.title"
                                  v-model="categoriesQuery">
                                  <label v-if="category.title.length<=20" :for="category.title">{{ category.title}}</label>
                                  <label v-else :for="category.title">{{ category.title.substring(0,20)+ ".." }}</label>
                                </div>
                              </li>
                            </ul>
                          </div>
                          <div class="filter-wrapper">
                            <h4>Subcategoria</h4>
                            <ul v-if="showLessSubcategory">
                              <li v-for="subcategory in subcategories.slice(0,10)">
                                <div class="form-check">
                                  <input 
                                  type="checkbox" 
                                  :id="subcategory" 
                                  class="form-check-input"
                                  :value="subcategory"
                                  v-model="subcategoriesQuery">
                                  <!-- <label :for="subcategory">{{ subcategory }}</label> -->

                                  <label v-if="subcategory.length<=20" :for="subcategory">{{ subcategory}}</label>
                                  <label v-else :for="subcategory">{{ subcategory.substring(0,20)+ ".." }}</label>
                                </div>
                              </li>
                            </ul>
                            <ul v-else>
                              <li v-for="subcategory in subcategories">
                                <div class="form-check">
                                  <input 
                                  type="checkbox" 
                                  :id="subcategory" 
                                  class="form-check-input"
                                  :value="subcategory"
                                  v-model="subcategoriesQuery">
                                  <!-- <label :for="subcategory">{{ subcategory }}</label> -->

                                  <label v-if="subcategory.length<=20" :for="subcategory">{{ subcategory}}</label>
                                  <label v-else :for="subcategory">{{ subcategory.substring(0,20)+ ".." }}</label>
                                </div>
                              </li>
                            </ul>
                            <button v-if="showLessSubcategory" @click="showLessSubcategory=false" class="view-more-btn">Ver más</button>
                            <button v-else @click="showLessSubcategory=true" class="view-more-btn">Ver menos</button>
                          </div>
                          <div class="filter-wrapper">
                            <h4>Fabricante</h4>
                            <ul v-if="showLessManufacturer">
                              <li v-for="manufacturer in manufacturers.slice(0,10)">
                                <div class="form-check">
                                  <input 
                                  type="checkbox" 
                                  :id="manufacturer" 
                                  class="form-check-input"
                                  :value="manufacturer"
                                  v-model="manufacturerQuery">
                                  <label v-if="manufacturer.length<=20" :for="manufacturer">{{ manufacturer}}</label>
                                  <label v-else :for="manufacturer">{{ manufacturer.substring(0,20)+ ".." }}</label>
                                </div>
                              </li>
                            </ul>
                            <ul v-else>
                              <li v-for="manufacturer in manufacturers">
                                <div class="form-check">
                                  <input 
                                  type="checkbox" 
                                  :id="manufacturer" 
                                  class="form-check-input"
                                  :value="manufacturer"
                                  v-model="manufacturerQuery">
                                  <label v-if="manufacturer.length<=20" :for="manufacturer">{{ manufacturer}}</label>
                                  <label v-else :for="manufacturer">{{ manufacturer.substring(0,20)+ ".." }}</label>
                                </div>
                              </li>
                            </ul>
                            <button v-if="showLessManufacturer" @click="showLessManufacturer=false"class="view-more-btn">Ver más</button>
                            <button v-else @click="showLessManufacturer=true" class="view-more-btn">Ver menos</button>
                          </div>
                          <div class="filter-wrapper">
                            <h4>Componente Base</h4>
                            <ul v-if="showLessBaseComponent">
                              <li v-for="baseComponent in baseComponents.slice(0,10)">
                                <div class="form-check">
                                  <input 
                                  type="checkbox" 
                                  :id="baseComponent.title" 
                                  class="form-check-input"
                                  :value="baseComponent._id"
                                  v-model="baseComponentsQuery">
                                  <label v-if="baseComponent.title.length<=20" :for="baseComponent.title">{{ baseComponent.title }}</label>
                                  <label v-else :for="manufacturer">{{ baseComponent.title.substring(0,20)+ ".." }}</label>
                                </div>
                              </li>
                            </ul>
                            <ul v-else>
                              <li v-for="baseComponent in baseComponents">
                                <div class="form-check">
                                  <input
                                  type="checkbox" 
                                  :id="baseComponent.title" 
                                  class="form-check-input"
                                  :value="baseComponent._id"
                                  v-model="baseComponentsQuery">
                                  <label v-if="baseComponent.title.length<=20" :for="baseComponent.title">{{ baseComponent.title }}</label>
                                  <label v-else :for="manufacturer">{{ baseComponent.title.substring(0,20)+ ".." }}</label>
                                </div>
                              </li>
                            </ul>
                            <button v-if="showLessBaseComponent" @click="showLessBaseComponent=false" class="view-more-btn">Ver más</button>
                            <button v-else @click="showLessBaseComponent=true" class="view-more-btn">Ver menos</button>
                          </div>
                          <div class="filter-wrapper">
                            <button 
                            class="custom-btn custom-btn--medium custom-btn--style-3 wide"
                            role="button" 
                            style="border: 1px solid #43a553; color: #43a553; margin: 10px 0;"
                            @click.prevent="searchBySide(1)">Buscar</button>
                          </div>
                        </div>
                      </div>

                      <div class="col-12 col-md-9">
                        <input 
                        type="text" 
                        name="" 
                        placeholder="¿Qué producto estás buscando? (Nombre, fabricante, categoría)"
                        class="searchBar"
                        v-model="query"
                        @keyup.enter="getProducts(query)"
                        >
                        <div class="row">
                          <!-- start item -->
                          <div 
                          class="col-12 col-sm-6 col-lg-4  js-isotope__item  category-1" v-for="(product, index) in products"
                          :key="index" 
                          style="margin-bottom: 20px;">
                          <div class="__item" style="border: 1px solid #ccc; border-radius: 4px;">
                            <div class="height:200px;">
                              <figure class="__image" style="padding:20px;">
                                <img 
                                  @click="showProductModalV(product)" 
                                  :src="'http://admin.agrobiosol.com.mx:45201/' + product.image" 
                                  style="width: 100%; cursor: pointer; border-radius: 4px;">
                              </figure>
                            </div>

                            <div class="__content" style="padding: 24px;padding-top: 0;">
                              <h5 @click="showProductModalV(product)" class="__content__title" style="cursor: pointer; text-align: center; padding-top: 10px;">{{ product.title}}</h5>
                              <span>{{ product.category}} | {{ product.manufacturer}}</span>
                              <div style="margin-top: 20px;">
                        <!-- <button
                          @click="addToQuote(product, index)"
                          style="border: none;cursor: pointer;"
                          :id="'quotation-btn-' + index"
                          v-if="true"
                          >
                          <span style="color: green; font-size: 16px;"><i style="padding-right: 8px;" class="fas fa-plus-circle"></i>Agregar a cotización </span>
                        </button> -->
                        <AddToQuoteBtn 
                        :title="product.title"
                        :category="product.category"
                        :subcategory="product.subcategory"
                        :index="index" />
                      </div>
                    </div>
                  </div>
                </div>
                <!-- end item -->

                <!-- <modal :product="product" v-if="showModal" @close="showModal = false" /> -->

              </div>
              <!-- paginator -->
              <div class="paginator-container">
                <div class="paginator-wrapper">
                  <button class="paginator-left" @click="previousPage(pageNumber)"><i class="fas fa-angle-left"></i></button>

                  <input
                  class="form-control page-number"
                  v-model="pageNumber"
                  @change="getProducts('', pageNumber)"> 
                  <span class="paginator-of">de</span>

                  <span>{{ totalPages }}</span>

                  <button class="paginator-right" @click="nextPage(pageNumber)"><i class="fas fa-angle-right"></i></button>
                </div>
              </div>
              <!-- paginator -->

            </div>
          </div>
        </div>
      </section>
      <!-- end section -->

      <Contact />
    </main>
    <!-- end main -->  
  </div>
</template>

<script>
import Map from '@/components/Map.vue'
import Contact from '@/components/Contact.vue'
import Modal from '@/components/Modal.vue'
import axios from 'axios'
import LoginModal from '@/components/LoginModal.vue'
import AddToQuoteBtn from '@/components/AddToQuoteBtn.vue'
import carousel from 'vue-owl-carousel'

export default {
  components: {
    Map,
    Contact,
    Modal,
    LoginModal,
    AddToQuoteBtn,
    carousel
  },
  data () {
    return {
      buttons: [],
      query: '',
      products: [],
      pageNumber: 1,
      totalPages: 0,
      showProductModal: false,
      product: {},
      showModal: false,
      quote: [],
      showQuotationBtn: [],
      categories: [],
      subcategories: [],
      categoriesQuery: [],
      subcategoriesQuery: [],
      searchMode: '',
      manufacturers: [
      'Agrinova', 'Agro Soluciones', 'Agrobiosol', 'Agrobiosol * Linea Premium', 'Agroserra Insumos', 'Amvac México', 'Arysta', 'Bayer', 'Biokrone', 'Codiagro', 'CYR', 'CYR Agroquimica', 'Daymsa', 'Diatomix', 'DVA', 'Gowan', 'Helm', 'Human Tech', 'Ingenieria Industrial', 'Internacional Quimica de Cobre', 'LAPISA', 'LUCAVA', 'NIMEX', 'PALAU', 'PROTECIN', 'Summit Agro', 'UPL', 'Valent', 'Versa'
      ],
      manufacturerQuery: [],
      baseComponents: [],
      baseComponentsQuery: [],
      addToQ: [],
      showLessSubcategory: true,
      showLessManufacturer: true,
      showLessBaseComponent: true
    }
  },
  created () {
    let query = this.$store.getters.search

    this.getProducts(query)

    window.addEventListener('touchstart', this.closeModal)
    window.addEventListener('click', this.closeModal)

    this.getCategories()
    this.getBaseComponents()
  },
  destroyed () {
    window.addEventListener('touchstart', this.closeModal)
    window.addEventListener('click', this.closeModal)
  },
  computed: {
    getQuotation () {
      return this.$store.getters.quotationItems
    },
    getQuery () {
      return this.$store.getters.search
    }
  },
  methods: {
    showLogin () {
      // this.showModal = true
      // this.showQuote = false

      this.$store.commit('show')
    },
    getCategories () {
      var vm = this
      // axios.get('http://localhost:8080/category/categories')
      axios.get('/category/categories')
      .then(res => {
        vm.categories = res.data.categories

        let categories = []

        for (let i = 0; i < vm.categories.length; i++) {
          categories.push(...vm.categories[i].subcategories)
        }

        function getCategories (arr) {
          return arr.filter((e, i) => arr.indexOf(e) >= i)
        }

        const defCategories = getCategories(categories)
        this.subcategories = defCategories
      })
      .catch(err => console.log(err))
    },
    getBaseComponents () {
      var vm = this
      // axios.get('http://localhost:8080/baseComponent/baseComponents')
      axios.get('/baseComponent/baseComponents')
      .then(res => {
        vm.baseComponents = res.data.baseComponents
      })
      .catch(err => console.log(err))
    },
    searchBySide (pageNumber) {
      var vm = this

      if (!pageNumber) {
        pageNumber = 1
      }

      let query = {}

      if (this.categoriesQuery.length > 0) {
        query.category = this.categoriesQuery
      }

      if (this.subcategoriesQuery.length > 0) {
        query.subcategory = this.subcategoriesQuery
      }

      if (this.manufacturerQuery.length > 0) {
        query.manufacturer = this.manufacturerQuery
      }

      if (this.baseComponentsQuery.length > 0) {
        let componentsArr = []
        for (let i = 0; i < this.baseComponentsQuery.length; i++) {
          componentsArr.push(this.baseComponentsQuery[i])
        }
        query.baseComponent = componentsArr
      }

      this.query = ''

      // axios.get('http://localhost:8080/product/productsCs?type=Otros productos&query=' + encodeURIComponent(JSON.stringify(query)) + '&pageNumber=' + pageNumber)
      axios.get('/product/productsCs?type=Otros productos&query=' + encodeURIComponent(JSON.stringify(query)) + '&pageNumber=' + pageNumber)
      .then(res => {
        vm.products = res.data.products
        vm.totalPages = res.data.totalPages
        vm.pageNumber = res.data.pageNumber
        vm.searchMode = 'searchSide'
      })
      .catch(err => console.log(err))
    },
    addToQuote (product, index) {
      let item = {
        code: product.code,
        title: product.title
      }

      this.$set(this.addToQ, index, false)

      this.$store.dispatch('quotationRequest', item)
    },
    persistData () {
      localStorage.setItem('quotation', JSON.stringify(this.quote))
    },
    getProducts (q, pageNumber) {
      var vm = this
      if (!pageNumber) {
        pageNumber = 1
      }

      // axios.get('http://localhost:8080/product/products?type=Otros productos&query=' + q + '&pageNumber=' + pageNumber)
      axios.get('/product/products?type=Otros productos&query=' + q + '&pageNumber=' + pageNumber)
      .then(res => {
        vm.products = res.data.products
        vm.totalPages = res.data.totalPages
        vm.pageNumber = res.data.pageNumber
        vm.searchMode = 'searchBar'

        for (let i = 0; i < vm.products.length; i++) {
          vm.addToQ.push(true)
        }
      })
      .catch(err => console.log(err))
    },
    nextPage () {
      this.pageNumber++
      this.getProducts(this.query, this.pageNumber)
    },
    previousPage () {
      this.pageNumber--
      this.getProducts(this.query, this.pageNumber)
    },
    showProductModalV (product) {
      this.showModal = true
      this.product = product
    },
    closeModal () {
      var productModal = document.getElementById('productModal')

      if (event.target === productModal) {
        this.showModal = false
      }
    }
  }
};
</script>

<style>
.paginator-wrapper {
  display: block;
  margin: 0 auto;
  text-align: center;
}

.page-number {
  width: 44px;
  display: inline-block;
}

.paginator-of {
  padding: 0 16px;
}

.paginator-left {
  background-color: none;
  height: 40px;
  width: 40px;
  border: none;
  text-align: center;
  display: inline-block;
  cursor: pointer;
  border-radius: 50%;
  margin-right: 72px;
}

.paginator-right {
  background-color: none;
  height: 40px;
  width: 40px;
  border: none;
  text-align: center;
  display: inline-block;
  cursor: pointer;
  border-radius: 50%;
  margin-left: 72px;
}

.paginator-left:focus {
  outline: 0;
}

.paginator-right:focus {
  outline: 0;
}

.paginator-left:hover {
  background-color: #ccc;
}

.paginator-right:hover {
  background-color: #ccc;
}


/* The Modal (background) */
.productModal {

  position: fixed; /* Stay in place */
  z-index: 9999; /* Sit on top */
  left: 0;
  top: 0;
  width: 100%; /* Full width */
  height: 100%; /* Full height */
  
  background-color: rgb(0,0,0); /* Fallback color */
  background-color: rgba(0,0,0,0.5); /* Black w/ opacity */
  transition: opacity .3s ease;
}

/* Modal Content/Box */
.product-modal-content {
  background-color: #fefefe;
  background-position: center;
  background-repeat: no-repeat;
  background-size: cover;
  margin: 5% auto;  
  /*margin-top: 15%;*/
  /*padding: 20px;*/
  /*border: 1px solid #888;*/
  width: 80%; /* Could be more or less, depending on screen size */
}

.modal-content-wrapper {
  padding: 30px;
}

.form-product-container {
  /*background-color: rgba(0,0,0,0.4);*/
  padding: 0 !important;
}

/* The Close Button */
.close {
  color: #aaa;
  float: right;
  font-size: 28px;
  font-weight: bold;
  display: none;
}

.close:hover,
.close:focus {
  color: black;
  text-decoration: none;
  cursor: pointer;
}

.product-info {
  font-size: 20rem;
}

.document-link-container {
  padding: 20px 0;
}

.product-info-item {
  padding: 8px 0; 
  margin-bottom: 0;
  margin-top: 0;
}

.product-info-item span{
  font-weight: bold;
}

.product-document {
  color: #43a553;
  cursor: pointer;
  text-decoration: underline;
}

.fa-file-pdf {
  padding-right: 8px;
}

.searchBar {
  width:100%;
  margin-top: 10px; 
  margin-bottom: 20px;
  border-radius:4px;
  font-size:16px;
  padding: 16px;
  /*border:1px solid #43a553;*/
  border:1px solid #ccc;
  outline: none;
  padding-left: 32px;
}

li {
  padding-bottom: 4px;
  font-size: 18px;
}

li input {
  margin-right: 8px;
}

.filter-wrapper {
  padding-bottom: 30px;
}

.filter-wrapper h4 {
  margin-bottom: 10px;
}

.view-more-btn {
  background-color: none;
  border: none;
  color: #333;
  padding: 8px 0;
  text-align: center;
  text-decoration: underline;
  display: inline-block;
  font-size: 16px;
  margin: 10px 0;
  cursor: pointer;
}

.view-more-btn:focus {
  outline: 0;
}
</style>